import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from './../index';
import { Button, message } from "antd";
import IntroGiamgia from './../../../../src/assets/pvi-benhhiemngheo/intro-giamgia.png';
import IntroPhamVi from './../../../../src/assets/pvi-benhhiemngheo/intro-phamvi.svg';
import IntroDoituongfrom from './../../../../src/assets/pvi-benhhiemngheo/intro-doituong.svg';
import Intro1 from './../../../../src/assets/pvi-benhhiemngheo/intro1.svg';
import IntroCharges from './../../../../src/assets/pvi-benhhiemngheo/intro-charges.svg';
import IntroCondition from './../../../../src/assets/pvi-benhhiemngheo/intro-condition.svg';
import IntroProcedure from './../../../../src/assets/pvi-benhhiemngheo/intro-procedure.svg';
import IntroGCN from './../../../../src/assets/pvi-benhhiemngheo/GCNMau.svg';
import IntroHotline from './../../../../src/assets/pvi-benhhiemngheo/intro-hotline.svg';
import Intro4 from './../../../../src/assets/pvi-benhhiemngheo/intro4.svg';

const Introduce = () => {
  const { goStep, CheckRenewals, OpenLink } = useContext(AuthContext);

  useEffect(() => {
    window.scrollTo(0, 0);
    localStorage.removeItem('dataSyncPBA');
  });

  const css = {
    btn: {
      color: "#009B4B",
      background: "#FFF",
      fontWeight: "bold",
      width: "100%",
      height: "44px",
      borderRadius: 8,
      border: "1px solid #009B4B",
    },
  };
  return (
    <div style={{ fontSize: 14, background: '#EDEFFA' }}>
      <div style={{ background: '#fff', padding:'20px 20px 10px 20px'}}>
        <img style={{ width: '100%' }} src={IntroGiamgia} alt="intro1" />
      </div>
      <div style={{ background: '#fff', padding:'0px 20px 0px 20px'}}>
        <img style={{ width: '100%' }} src={IntroPhamVi} alt="intro1" />
      </div>
      <div style={{ background: '#fff', padding: 20}}>
        <img style={{ width: '100%' }} src={IntroDoituongfrom} alt="intro1" />
      </div>
      {/* <img style={{ width: '100%' }} src={Intro1} alt="intro1" /> */}
      <img
        onClick={() => {
          OpenLink(
            "https://cdn.globalcare.vn/private/document/pdf/benh-hiem-ngheo/pvi/Bieu_phi_BH_benh_hiem_ngheo_9_2018.pdf"
          );
        }}
        style={{ width: '100%', margin: '7px 0px 0px 0px' }}
        src={IntroCharges} alt="intro1"
      />
      <img
        onClick={() => {
          OpenLink(
            "https://cdn.globalcare.vn/private/document/pdf/benh-hiem-ngheo/pvi/QTBH_benh_hiem_ngheo_9_2018.pdf"
          );
        }}
        style={{ width: '100%', margin: '7px 0px 0px 0px' }}
        src={IntroCondition} alt="intro2"
      />
      <img
        onClick={() => {
          OpenLink(
            "https://cdn.globalcare.vn/private/document/pdf/benh-hiem-ngheo/pvi/GCN_BENH_HIEM_NGHEO_2022_05_17.pdf"
          );
        }}
        style={{ width: '100%', margin: '7px 0px 0px 0px' }}
        src={IntroGCN} alt="intro3"
      />
      <img
        onClick={() => {
          OpenLink(
            "https://cdn.globalcare.vn/private/document/pdf/benh-hiem-ngheo/pvi/HDM_BH_BENH_HIEM_NGHEO.pdf"
          );
        }}
        style={{ width: '100%', margin: '7px 0px 0px 0px' }}
        src={Intro4} alt="intro4"
      />
      <img style={{ width: '100%', margin: '7px 0px 0px 0px' }} src={IntroProcedure} alt="intro1" />
      <img style={{ width: '100%', margin: '7px 0px 100px 0px' }} src={IntroHotline} alt="intro1" />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          position: "fixed",
          width: "100%",
          maxWidth: 800,
          bottom: 0,
          height: 86,
          background: "#fff",
          borderRadius: "16px 16px 0px 0px",
          alignItems: "center",
          boxShadow: "0px -4px 8px 0px #0000001A",
          padding: "0px 10px",
        }}
      >
        <Button
          loading={false}
          onClick={() => goStep(2)}
          style={{ ...css.btn, color: "#fff", background: "#2A3790", marginBottom: 10 }}
          type="#009B4B"
        >
          Tiếp tục
        </Button>
      </div>
    </div>
  );
};

export default Introduce;
